import { useState, useEffect, useMemo } from 'react';
import { GetFiltersResponse, getFilters } from '@card/commonlib';

export function useFilterOptions() {
  const [filters, setFilters] = useState<GetFiltersResponse | null>(null);

  useEffect(() => {
    getFilters().then(setFilters);
  }, []);

  const options = useMemo(() => {
    if (filters === null) return null;
    return {
      banks: filters.banks,
      cardBrands: filters.card_brands,
      processorNames: filters.current_processor_names,
      reportTypes: filters.reportTypes,
      chargebackCategories: filters.chargebackCategories,
      chargebackStatuses: filters.chargebackStatuses,
      currencies: filters.current_currencies
    };
  }, [filters]);

  return options;
}
